<template>
  <div>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!--Dialog para adicionar um campo personalizado na tarefa modelo-->
    <v-dialog v-model="dialogAddCustomField" @keydown.enter="confirmAddCustomField()" @keydown.esc="cancelAddCustomField()" persistent max-width="400" scrollable>
      <v-card>
        <v-card-text justify-center>
          <v-text-field id="titleCustomField" label="Digite o título do campo personalizado" v-model="customFieldTitle"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="add_custom_field_confirm" class="mx-0" :loading="loadingAddCustomField" flat color="primary" @click.native="confirmAddCustomField()">Salvar</v-btn>
          <v-btn id="add_custom_field_cancel" class="mx-0" flat @click.native="cancelAddCustomField()" :loading="loadingAddCustomField">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Index-->
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
        <v-tooltip bottom>
          <v-chip slot="activator" style="height:20px;margin-top:0px;" outline color="primary" @click="$store.commit('dialogBeta/change_values', { text: 'Crie mensagens para serem enviadas de forma automática para os seus clientes!', link:`https://app.illis.com.br/#/form_view/NTQ0`, showDialog: true, customText: '' })" class="beta">
            beta<v-icon>play_arrow</v-icon></v-chip>
          <span>Clique no botão beta para mais informações</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn color="primary" @click="create" class="mb-4">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          :rows-per-page-items="[10,20,30,{'text':'Todos','value':-1}]"
          class="elevation-1"
          :custom-filter="customizedFilter"  style="word-break: break-all;">
            <template slot="items" slot-scope="props">
              <td> Quando 
                <strong>{{ translate('value.tasktemplate_automation_type').find((value) => value['value'] === props.item.type)['text'] }}</strong>
                o
                <strong>{{ props.item.fields.map(field => { return translate('value.tasktemplate_automation_fields').find((value) => value['value'] === field)['text']}).join() }}</strong>
                de um tarefas para 
                <strong>({{ props.item.values_text }})</strong>
                <strong>{{ translate('value.tasktemplate_automation_action').find((value) => value['value'] === props.item.action)['text'] }}</strong>
                <strong v-if="props.item.action == 'create_task'">: ({{ props.item.config_text }})</strong>
              </td>
              <td align="center">
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="dialogDelete(props.item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-layout>
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="950px" height="400px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-title primary-title style="padding-top: 0px;padding-bottom: 0px;height: 65px;">
          <v-layout wrap justify-space-between align-center>
            <v-flex grow>
              <span class="headline">{{formTitle}}</span>
            </v-flex>
            <v-flex shrink>
              <v-btn icon fab @click="close()">
                <v-icon color="black">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding-top:0px">
          <v-form v-model="valid" @keyup.native.esc="close()" @keyup.native.ctrl.enter="save()" ref="form">
            <v-select
              :items="actionItems"
              v-model="editedItem.action"
              @change="selectAutomation"
              label="Selecione o tipo da automação"
            ></v-select>
            <v-container v-if="editedItem.action == 'send_message'" fluid grid-list-md style="padding-top:0px">
              <v-layout row align-baseline wrap>
                <v-flex shrink><span>Quando alterar o status para</span>&nbsp;</v-flex>
                <v-flex shrink>
                  <p-select-modal-editable p-select-modal-editable id="task_status_id" ref="selectEditableStatus" :companyId="$auth.user().company_id" :clearable="false" :label="translate('table.tasks.field.task_status_id')" v-model="editedItem.values" :rules="requiredManyRule(translate('table.tasks.field.task_status_id'))" entity="task_status" :values="status_fields" multiple>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="status_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="status_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                        </v-flex>
                        <v-switch label="Status de conclusão" :value=3 v-model="status_fields.identifier"></v-switch>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                </v-flex>
                <v-flex shrink>&nbsp;<span>enviar mensagem no WhatsApp que está no campo</span>&nbsp;</v-flex>
                <!-- <v-flex xs2>
                  <v-autocomplete
                    :items="translate('value.tasktemplate_automation_send_message_type')"
                    label="Tipo"
                    @change="changeType()"
                    v-model="editedItem.config['type']"
                    :rules="requiredRule('Tipo')"
                  ></v-autocomplete>
                </v-flex> -->
                <!-- <v-flex shrink>&nbsp;<span>que está no campo</span>&nbsp;</v-flex> -->
                <v-flex xs2>
                  <v-autocomplete
                    v-if="showCustomFieldType"
                    :loading="loadingMsgFields"
                    :items="msgFieldsItems"
                    item-value="id"
                    item-text="title"
                    :no-data-text="loadingMsgFields ? 'Carregando...' : `Favor inserir um campo personalizado de ${this.editedItem.config['type'] === 'email' ? 'E-mail' : 'Telefone'}`"
                    label="Campos"
                    v-model="editedItem.config['msgField']"
                    :rules="requiredRule('Campos')"
                  >
                  <template v-slot:prepend-item v-if="editedItem.config['type'] !== ''">
                    <v-layout align-center>
                      <v-flex grow>
                        <v-btn :id="'add_custom_field'" block outline @click="clickAddCustomField(editedItem.config['type'] === 'wpp' ? 'phone' : 'email')" color="primary">Adicionar campo personalizado de {{ editedItem.config['type'] === 'wpp' ? 'Telefone' : 'E-mail' }}</v-btn>
                      </v-flex>
                      <v-flex shrink>
                        <v-tooltip bottom>
                          <v-btn slot="activator" icon @click="closeCustomFieldType()">
                            <v-icon>close</v-icon>
                          </v-btn>
                          <span>Fechar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-autocomplete>
                </v-flex>
              </v-layout>
              <strong>Digite abaixo a mensagem que será enviada</strong> 
              <div class="e-content e-lib e-keyboard" id="automation_message_text" contenteditable="true" tabindex="0" style="outline: 0px solid transparent; padding: 15mm 15mm; border: 1px solid rgba(0, 0, 0, 0.12);" data-tribute="true">
              </div>
              <span >Utilize o <strong>@</strong> para adicionar informações personalizadas</span>
              <v-layout row align-baseline wrap>
                <v-flex xs12>
                  <v-autocomplete
                    v-if="showCustomFieldType"
                    :loading="loadingFileFields"
                    :items="fileFieldsItems"
                    item-value="id"
                    item-text="title"
                    :no-data-text="loadingFileFields ? 'Carregando...' : `Favor inserir um campo personalizado de arquivo`"
                    label="Para enviar arquivos, selecione o campo personalizado (opcional)"
                    hint="Será enviado o link junto a mensagem acima para fazer o download dos arquivos"
                    v-model="editedItem.config['fileFields']"
                    persistent-hint
                    multiple
                  >
                  <template v-slot:prepend-item>
                    <v-layout align-center>
                      <v-flex grow>
                        <v-btn :id="'add_custom_field'" block outline @click="clickAddCustomField('files')" color="primary">Adicionar campo personalizado de arquivo</v-btn>
                      </v-flex>
                      <v-flex shrink>
                        <v-tooltip bottom>
                          <v-btn slot="activator" icon @click="closeCustomFieldType()">
                            <v-icon>close</v-icon>
                          </v-btn>
                          <span>Fechar</span>                  
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container v-else-if="editedItem.action == 'create_task'" fluid grid-list-md style="padding-top:0px">
              <v-layout row align-baseline wrap>
                <v-flex shrink><span>Quando alterar o status para</span>&nbsp;</v-flex>
                <v-flex shrink>
                  <p-select-modal-editable p-select-modal-editable id="task_status_id" ref="selectEditableStatus" :companyId="$auth.user().company_id" :clearable="false" :label="translate('table.tasks.field.task_status_id')" v-model="editedItem.values" :rules="requiredManyRule(translate('table.tasks.field.task_status_id'))" entity="task_status" :values="status_fields" multiple>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="status_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="status_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                        </v-flex>
                        <v-switch label="Status de conclusão" :value=3 v-model="status_fields.identifier"></v-switch>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                </v-flex>
                <v-flex shrink>&nbsp;<span>criar uma tarefa usando o modelo</span>&nbsp;</v-flex>
                <v-flex xs2>
                  <v-autocomplete validate-on-blur v-model="editedItem.config['tasktemplate_id']" :items="taskTemplateItems" item-text="id_text" item-value="id" label="Modelo de Tarefas (POP)" 
                  :rules="requiredRule(translate('table.' + entity + '.field.tasktemplate_id'))"
                  
                  :filter="filterAutocomplete"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="save()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style >
  /* [contenteditable] {
    outline: 0px solid transparent;
  } */
  .menu_content {
    padding: 0 10px 10px 10px;
  }
  .tribute-container {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    max-height: 300px;
    max-width: 500px;
    min-width: 200px;
    overflow: auto;
    display: block;
    z-index: 999999;
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%) !important;
    background: rgb(255, 255, 255);
    font-family:Roboto,sans-serif;
  }
  .tribute-container ul {
    margin: 0;
    margin-top: 2px;
    padding: 0;
    list-style: none;
  }
  .tribute-container li {
    padding: 5px 5px;
    cursor: pointer;
  }
  /* // Quando passa o mouse por cima */
  .tribute-container li.highlight {
    background: rgb(243, 243, 243);
    font-family:Roboto,sans-serif;
  }
</style>

<script>
  /* eslint-disable no-undef */
  import Tribute from 'tributejs'
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import PConfirm from './../shared/PConfirm'
  import Swatches from 'vue-swatches'
  import PSelectModalEditable from './../shared/PSelectModalEditable'
  
  export default {
    mixins: [crud, rules],
    components: {
      PConfirm, Swatches, PSelectModalEditable
    },
    props: {
      tasktemplate_id: {
        type: Number,
        default: null
      }
    },
    data: () => ({
      entity: 'tasktemplate_automation',
      search: '',
      customFieldTitle: '',
      typeAddCustomField: '',
      tribute: null,
      dialog: false,
      dialogConfirm: false,
      dialogAddCustomField: false,
      showCustomFieldType: true,
      loadingAddCustomField: false,
      loadingFileFields: false,
      loadingMsgFields: false,
      msgFieldsItems: [],
      fileFieldsItems: [],
      items: [],
      taskTemplateItems: [],
      actionItems: [{value: 'send_message', text: 'Enviar WPP ao alterar o status'}, {value: 'create_task', text: 'Criar tarefa ao alterar o status'}],
      status_fields: {id_text: '', active: true, color: '', identifier: null},
      editedItem: {tasktemplate_id: 0, type: 2, fields: ['task_status_id'], values: [], action: '', config: {}},
      defaultItem: {tasktemplate_id: 0, type: 2, fields: ['task_status_id'], values: [], action: '', config: {}}
    }),
    created () {
      Object.assign(this.editedItem, {'tasktemplate_id': this.tasktemplate_id})
      Object.assign(this.defaultItem, {'tasktemplate_id': this.tasktemplate_id})
      this.$http.get(`api/${this.entity}?where=tasktemplate_id=${this.tasktemplate_id}`).then((res) => {
        this.items = res.body.map(automation => {
          return this.mountItemAutomation(automation)
        })
        this.$emit('itemsLength', this.items.length)
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
      })
      this.$http.get(`api/get_tasktemplate_team`).then(res => {
        this.taskTemplateItems = res.body
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
      })
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
    },
    methods: {
      filterAutocomplete (item, queryText, itemText) {
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(query) > -1
      },
      save () {
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        if (this.editedItem['action'] === 'send_message') {
          if (document.getElementById('automation_message_text').innerText.replaceAll('\\n', '').replace(/\s/g, '') === '') {
            this.$store.commit('snackbar/change_values', {
              text: 'Favor inserir a mensagem',
              color: 'warning',
              dialog: true
            })
            return false
          }
          this.editedItem['config']['message'] = document.getElementById('automation_message_text').innerHTML
        }
        this.$store.commit('loader/change_dialog', true)
        let editedItem = JSON.parse(JSON.stringify(this.editedItem))
        editedItem['fields'] = editedItem['fields'].join()
        editedItem['values'] = editedItem['values'].join()
        editedItem['config'] = JSON.stringify(editedItem['config'])
        if (this.view === 2) {
          this.$http.post('api/' + this.entity, editedItem).then(
            (res) => {
              let item = this.mountItemAutomation(res.body)
              this.items.push(item)
              this.$emit('itemsLength', this.items.length)
              this.$socket.emit('generalDetailsEvent', {
                data: item,
                details: 'automations',
                responseEvent: 'addSocketDetails',
                room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate_id
              })
              this.close()
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true })
            },
            err => {
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível incluir o registro de ' +
                  this.translate('table.' + this.entity + '.title')[0] +
                  ', reporte o erro.',
                color: 'error',
                dialog: true
              })
            })
        } else if (this.view >= 3) {
          this.$http.put('api/' + this.entity + '/' + editedItem['id'], editedItem).then(
            (res) => {
              let item = this.mountItemAutomation(res.body)
              Object.assign(this.items.find((val) => { return val.id === item.id }) || {}, item)
              this.$socket.emit('generalDetailsEvent', {
                data: item,
                details: 'automations',
                responseEvent: 'editSocketDetails',
                room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate_id
              })
              this.close()
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', { text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', color: 'success', dialog: true })
            },
            err => {
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', { text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true })
            }
          )
        }
      },
      create () {
        this.view = 2
        this.dialog = this.view !== 1
        this.$refs.form.resetValidation()
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      },
      selectAutomation (val) {
        if (val === 'send_message') {
          this.createSendMessage()
        } else if (val === 'create_task') {
          this.createCreateTask()
        }
      },
      editItem (item, view = 3) {
        this.view = view
        this.dialog = this.view !== 1
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)))
        if (this.editedItem['action'] === 'send_message') {
          this.editSendMessage()
        } else if (this.editedItem['action'] === 'create_task') {
          this.editCreateTask()
        }
        setTimeout(() => {
          this.$refs.selectEditableStatus.getValues()
        }, 500)
      },
      deleteItem () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.delete(`api/${this.entity}/${this.editedItem.id}`).then(
          (res) => {
            // utilizado o splice pois ao atribuir valor diretamente a uma variavel a referencia do ponteiro é alterada
            this.items.splice(this.items.findIndex((val) => { return val.id === res.body.id }), 1)
            this.$emit('itemsLength', this.items.length)
            this.$socket.emit('generalDetailsEvent', {
              data: res,
              details: 'automations',
              responseEvent: 'deleteSocketDetails',
              room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate_id
            })
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', { text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' excluído com sucesso!', color: 'success', dialog: true })
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível deletar o registro de ' +
                this.translate('table.' + this.entity + '.title')[0] +
                ', reporte o erro.',
              color: 'error',
              dialog: true
            })
          }
        )
        this.closeDialogDelete()
      },
      dialogDelete (item) {
        this.dialogConfirm = true
        // editedItem = item tem que ser = se não não pega vinculo quando tenta encontrar o index no deleteItem
        this.editedItem = item
      },
      mountItemAutomation (item) {
        item['fields'] = item['fields'].split(',')
        item['values'] = item['values'].split(',').map(Number)
        item['config'] = JSON.parse(item['config'])
        return item
      },
      closeDialogDelete () {
        this.dialogConfirm = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      },
      close () {
        this.view = 1
        this.dialog = this.view !== 1
        if (document.getElementById('automation_message_text')) {
          document.getElementById('automation_message_text').innerHTML = ''
        }
        this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
      },
      closeCustomFieldType () {
        // variavel showCustomFieldType recebe false e depois true para pdoer fechar o quadro de seleção quando o usuário aperta no x
        this.showCustomFieldType = false
        setTimeout(() => {
          this.showCustomFieldType = true
        }, 100)
      },
      createDocument (fields) {
        let element = document.getElementById('automation_message_text')
        if (this.tribute !== null) {
          this.tribute.detach(document)
          console.log('detach')
        }
        this.tribute = new Tribute({
          values: fields,
          // column to search against in the object (accepts function or string)
          lookup: 'filterText',
          // column that contains the content to insert by default
          fillAttr: 'title',
          noMatchTemplate: `<a class="v-list__tile v-list__tile--link theme--light" style="height: 35px;padding-left:10px;padding-right:5px"><div class="v-list__tile__content"><div class="v-list__tile__title">Campo não encontrado</div></div></a>`,
          selectTemplate: (item) => {
            return `<illis_automation class="illis_automation" field=${item.original.id} category=${item.original.category} type=${item.original.type} contenteditable="false">@${item.original.title} (${item.original.categoryText})</illis_automation>`
          },
          menuItemTemplate: (item) => {
            return `<a class="v-list__tile v-list__tile--link theme--light" style="height: 35px;padding-left:10px;padding-right:5px"><div class="v-avatar" style="height: 30px; width: 30px; padding-right:15px;"><div><div dark="" class="avatar_user teal_border"><h3>${item.original.category === 'field_client' ? 'C' : (item.original.category === 'custom_field' ? 'CP' : (item.original.category === 'other_field' ? 'O' : 'T'))}</h3></div></div></div> <div class="v-list__tile__content"><div class="v-list__tile__title">${item.original.title}</div><div class="v-list__tile__sub-title" style="color:grey">${item.original.categoryText}</div></div></a>`
          }
        })
        console.log('this.tribute', this.tribute)
        this.tribute.attach(element)
      },
      clickAddCustomField (typeCustomField) {
        this.typeAddCustomField = typeCustomField
        this.customFieldTitle = ''
        this.dialogAddCustomField = true
      },
      confirmAddCustomField () {
        this.loadingAddCustomField = true
        if (this.editedItem['title'] === '') {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor preencher o campo!', color: 'warning', dialog: true
          })
          document.getElementById('titleCustomField').click()
          return 0
        }
        let values = { origin_field_name: 'tasktemplate_id', tasktemplate_id: this.tasktemplate_id, title: this.customFieldTitle, type: this.typeAddCustomField }
        // let values = { company_id: 25, id_text: '', origin_field_name: 'tasktemplate_id', task_id: null, tasktemplate_id: this.tasktemplate_id, title: this.customFieldTitle, type: 'phone', value: null, value_item: null }
        this.$http.post('api/custom_fields', values).then((res) => {
          // Ja insere o valor adicionado no store do customField
          this.$store.commit(`customField/add_value`, res.body)
          if (this.typeAddCustomField === 'files') {
            this.fileFieldsItems.unshift(res.body)
            if (typeof this.editedItem.config['fileFields'] !== 'object') this.editedItem.config['fileFields'] = []
            this.editedItem.config['fileFields'].push(res.body)
          } else {
            this.msgFieldsItems.unshift(res.body)
            this.editedItem.config['msgField'] = res.body['id']
          }
          // ---- Inicio Socket----
          // adiciona na tarefa e na tarefa modelo
          this.$socket.emit('generalEvent', {
            data: res.body,
            responseEvent: 'addSocketCustomField',
            room: `tasktemplates_cf_${this.tasktemplate_id}`
          })
          this.$store.commit('snackbar/change_values', { text: 'Campo personalziado incluído com sucesso!', color: 'success', dialog: true })
          this.loadingAddCustomField = false
          this.cancelAddCustomField()
        }, err => {
          this.loadingAddCustomField = false
          console.log(err)
          this.loadingAddField = false
          this.$store.commit('snackbar/change_values', { text: 'Não foi possível incluir campo personalizado, reporte o erro.', color: 'error', dialog: true })
        })
      },
      cancelAddCustomField () {
        this.dialogAddCustomField = false
        this.customFieldTitle = ''
      },
      //   Metodos SendMessage ---------------------------------------
      createSendMessage () {
        this.editedItem.config = {type: 'wpp', phone: '', message: ''}
        this.defaultItem.config = {type: 'wpp', phone: '', message: ''}
        this.editedItem.action = 'send_message'
        this.defaultItem.config = 'send_message'
        this.msgFieldsItems = []
        this.fileFieldsItems = []
        this.getCustomFields()
        this.getCustomFieldsByType(this.editedItem.config['type'] === 'wpp' ? 'phone' : 'email')
        this.getCustomFieldsByType('files')
        setTimeout(() => {
          document.getElementById('automation_message_text').innerHTML = ''
        }, 500)
      },
      editSendMessage () {
        this.getCustomFields()
        this.getCustomFieldsByType(this.editedItem.config['type'] === 'wpp' ? 'phone' : 'email')
        this.getCustomFieldsByType('files')
        setTimeout(() => {
          document.getElementById('automation_message_text').innerHTML = this.editedItem['config']['message']
        }, 500)
      },
      changeType () {
        this.editedItem.config['msgField'] = null
        this.getCustomFieldsByType(this.editedItem.config['type'] === 'wpp' ? 'phone' : 'email')
      },
      // getCustomFields busca os campos personalizados de acordo com o tipo selecionado
      getCustomFieldsByType (type = '') {
        this.loadingMsgFields = true
        this.loadingFileFields = true
        this.$http.get(`api/custom_fields?origin_field_name="tasktemplate_id"&tasktemplate_id=${this.tasktemplate_id}&where=type='${type}'`).then((res) => {
          // caso o tipo seja arquivo coloca na variavel de arquivo, se for de outro tipo coloca na msgfield
          type === 'files' ? this.fileFieldsItems = res.body : this.msgFieldsItems = res.body
          this.loadingMsgFields = false
          this.loadingFileFields = false
        }, err => {
          console.log(err)
          this.loadingFileFields = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os campos.', color: 'error', dialog: true})
        })
      },
      getCustomFields () {
        let customFields = this.$store.state.customField.values
        // insere os campos padroes
        let fields = JSON.parse(JSON.stringify(this.translate('value.tasktemplate_document')))
        // insere os campos personalizados
        customFields.map((val) => fields.push({ id: val['id'], title: val['title'], category: 'custom_field', type: val['type'] }))
        // inclui algumas propriedades para serem usadss no tribute
        fields.map((field) => {
          let categoryText = field['category'] === 'field_client' ? 'Cliente' : (field['category'] === 'custom_field' ? 'Campo personalizado' : (field['category'] === 'other_field' ? 'Outros Campos' : 'Tarefa'))
          field['categoryText'] = categoryText
          field['filterText'] = (categoryText + ' ' + field['title'])
        })
        setTimeout(() => {
          this.createDocument(fields)
        }, 100)
      },
      //   Metodos CreateTask ---------------------------------------
      createCreateTask () {
        this.editedItem['config'] = {tasktemplate_id: ''}
      },
      editCreateTask () {
        console.log('editCreateTask')
      }
    },
    computed: {
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'type', width: '70%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TemplateAutomation.vue